import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M11.553 6.923c1.458-.43 2.097-2.029 2.097-3.492C13.65 1.658 12.804 0 10.758 0 8.812 0 7.946 1.489 7.866 3.175c1.95.245 3.329 1.648 3.687 3.748zm4.99 3.473a3.291 3.291 0 0 0-.681-1.065 6.332 6.332 0 0 0-2.334-1.513 4.516 4.516 0 0 1-1.909.831 6.023 6.023 0 0 1-.532 1.988c.891.406 1.68.957 2.351 1.648.421.433.756.954.996 1.548l.067.167H18l-1.457-3.604zm-9.285 1.263c2.029 0 2.892-1.904 2.892-3.611 0-1.773-.846-3.432-2.892-3.432S4.35 6.258 4.35 8.048c0 1.756.845 3.611 2.908 3.611zm5.104 1.671a6.353 6.353 0 0 0-2.627-1.613l-2.476 2.476-2.48-2.48a6.358 6.358 0 0 0-2.64 1.617 3.291 3.291 0 0 0-.681 1.065L0 18h14.5l-1.457-3.604a3.285 3.285 0 0 0-.681-1.066z" />
  </svg>
);

export default SvgComponent;
